/* ═══════════════════════════════════════════════════════════════════
   UNMARKED — homepage sections
   assets/unmarked-home.js
   Loaded by every unmarked-* section. Guarded so duplicate <script>
   tags don't double-bind, and re-inits on Shopify's section lifecycle
   events so it works inside the theme editor.
   ═══════════════════════════════════════════════════════════════════ */
(function(){
'use strict';

if (window.__unmarkedHome) return;
window.__unmarkedHome = true;

var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var DPR    = Math.min(window.devicePixelRatio || 1, 2);

/* Dawn's body is light. Paint it dark once any unmarked section exists. */
function paintBody(){
  if (document.querySelector('.um')) document.body.classList.add('um-dark');
  if (!document.querySelector('.um-grid-bg') && document.querySelector('.um')){
    var g = document.createElement('div');
    g.className = 'um-grid-bg';
    g.setAttribute('aria-hidden','true');
    document.body.insertBefore(g, document.body.firstChild);
  }
}

/* ── scroll reveal ────────────────────────────────────────────────── */
var io = ('IntersectionObserver' in window)
  ? new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting){ en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, {threshold:0.15})
  : null;

function initReveal(root){
  var els = root.querySelectorAll('.um-rv:not([data-um-rv])');
  [].forEach.call(els, function(el){
    el.setAttribute('data-um-rv','1');
    if (io) io.observe(el); else el.classList.add('is-in');
  });
}

/* ═══════════════════════════════════════════════════════════════════
   CHROME HEADLINE
   The gradient is fixed; the light source travels across it. That's
   what reads as metal rather than as a moving gradient.
   ═══════════════════════════════════════════════════════════════════ */
var chromeEls = [];
var tx = 50, ty = 45, cx = 50, cy = 45, chromeRunning = false;

function chromeFrame(){
  cx += (tx - cx) * 0.08;
  cy += (ty - cy) * 0.08;
  var pos = cx.toFixed(1) + '% ' + cy.toFixed(1) + '%';
  for (var i = 0; i < chromeEls.length; i++) chromeEls[i].style.backgroundPosition = pos;
  requestAnimationFrame(chromeFrame);
}

function initChrome(root){
  var els = root.querySelectorAll('[data-um-chrome]:not([data-um-chrome-init])');
  [].forEach.call(els, function(el){
    el.setAttribute('data-um-chrome-init','1');
    chromeEls.push(el);
  });
  if (chromeEls.length && !chromeRunning && !reduce){
    chromeRunning = true;
    chromeFrame();
  }
}

window.addEventListener('pointermove', function(e){
  tx = e.clientX / window.innerWidth * 100;
  ty = 20 + e.clientY / window.innerHeight * 60;
}, {passive:true});

window.addEventListener('scroll', function(){
  ty = 25 + (window.scrollY / window.innerHeight) * 70;
}, {passive:true});

/* ═══════════════════════════════════════════════════════════════════
   PASS RAIL — the signature
   ═══════════════════════════════════════════════════════════════════ */

/* 256-step lookup table between the two brand colours. Photo luminance
   maps through it — this is the thermal/duotone treatment. */
function buildLUT(a, b){
  var c = document.createElement('canvas');
  c.width = 256; c.height = 1;
  var x = c.getContext('2d');
  var g = x.createLinearGradient(0, 0, 256, 0);
  g.addColorStop(0, '#0a0a09');
  g.addColorStop(0.42, a);
  g.addColorStop(1, b);
  x.fillStyle = g; x.fillRect(0, 0, 256, 1);
  return x.getImageData(0, 0, 256, 1).data;
}

function duotone(ctx, w, h, a, b){
  try {
    var img = ctx.getImageData(0, 0, w, h), d = img.data, lut = buildLUT(a, b);
    for (var i = 0; i < d.length; i += 4){
      var l = (d[i] * 0.299 + d[i+1] * 0.587 + d[i+2] * 0.114) | 0, o = l * 4;
      d[i] = lut[o]; d[i+1] = lut[o+1]; d[i+2] = lut[o+2];
    }
    ctx.putImageData(img, 0, 0);
  } catch (err){
    /* Cross-origin image, pixels unreadable — composite instead. */
    var g = ctx.createLinearGradient(0, h, w, 0);
    g.addColorStop(0, a); g.addColorStop(1, b);
    ctx.globalCompositeOperation = 'color';
    ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
    ctx.globalCompositeOperation = 'source-over';
  }
}

/* Procedural stand-in used when a pass has no image set. */
function thermalFill(ctx, w, h, a, b){
  var g = ctx.createLinearGradient(0, h, w, 0);
  g.addColorStop(0, a); g.addColorStop(1, b);
  ctx.fillStyle = g; ctx.fillRect(0, 0, w, h);
  ctx.globalCompositeOperation = 'overlay';
  for (var i = 0; i < 120; i++){
    ctx.beginPath();
    ctx.ellipse(Math.random()*w, Math.random()*h, Math.random()*w*0.42,
                Math.random()*h*0.15, Math.random()*3, 0, 7);
    ctx.fillStyle = 'rgba(' + (Math.random() > 0.5 ? '0,0,0' : '255,255,255') +
                    ',' + (Math.random()*0.42) + ')';
    ctx.fill();
  }
  ctx.globalCompositeOperation = 'source-over';
}

/* the stepped pixel edge lifted from the lanyard artwork */
function pixelEdge(ctx, w, h, panelH, a, b){
  var u = Math.max(10, w / 17);
  for (var x = 0; x < w; x += u){
    var top = Math.floor(Math.random() * 3), k;
    for (k = 0; k < top; k++){
      ctx.fillStyle = Math.random() < 0.5 ? '#ffffff' : b;
      ctx.fillRect(x, k * u, u, u);
    }
    var bot = Math.floor(Math.random() * 4);
    for (k = 0; k < bot; k++){
      ctx.fillStyle = '#0c0c0b';
      ctx.fillRect(x, panelH - (k + 1) * u, u, u);
    }
    if (Math.random() < 0.3){
      ctx.fillStyle = Math.random() < 0.5 ? a : b;
      ctx.fillRect(x, panelH + Math.floor(Math.random() * 2) * u, u, u);
    }
  }
}

function paintPass(p){
  var cv   = p.querySelector('canvas');
  var face = p.querySelector('.um-pass__face--front');
  if (!cv || !face) return;
  var w = cv.width  = Math.round(face.clientWidth  * DPR);
  var h = cv.height = Math.round(face.clientHeight * DPR);
  if (!w || !h) return;

  var ctx = cv.getContext('2d');
  var a = p.dataset.a || '#5FBCA9';
  var b = p.dataset.b || '#EF7C11';
  var panelH = h * 0.72;

  ctx.clearRect(0, 0, w, h);
  ctx.fillStyle = '#0c0c0b'; ctx.fillRect(0, 0, w, h);

  function finish(){
    ctx.fillStyle = '#0c0c0b';
    ctx.fillRect(0, panelH, w, h - panelH);
    pixelEdge(ctx, w, h, panelH, a, b);
  }

  var src = p.dataset.photo;
  if (src){
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function(){
      var r  = Math.max(w / im.width, panelH / im.height);
      var dw = im.width * r, dh = im.height * r;
      ctx.drawImage(im, (w - dw)/2, (panelH - dh)/2, dw, dh);
      duotone(ctx, w, panelH, a, b);
      finish();
    };
    im.onerror = function(){ thermalFill(ctx, w, panelH, a, b); finish(); };
    im.src = src;
  } else {
    thermalFill(ctx, w, panelH, a, b);
    finish();
  }
}

/* ── tilt: pointer on desktop, gyro on phone ──────────────────────── */
var tiltQueued = false, tiltX = 0, tiltY = 0;

function allPasses(){ return document.querySelectorAll('.um-pass'); }

function applyTilt(){
  tiltQueued = false;
  var list = allPasses();
  for (var i = 0; i < list.length; i++){
    if (list[i].classList.contains('is-flipped')) continue;
    list[i].style.transform = 'rotateY(' + tiltX.toFixed(2) + 'deg) rotateX(' + tiltY.toFixed(2) + 'deg)';
  }
}
function queueTilt(x, y){
  tiltX = x; tiltY = y;
  if (!tiltQueued){ tiltQueued = true; requestAnimationFrame(applyTilt); }
}

if (!reduce){
  window.addEventListener('pointermove', function(e){
    if (e.pointerType !== 'mouse') return;
    queueTilt((e.clientX / window.innerWidth  - 0.5) * 22,
             -(e.clientY / window.innerHeight - 0.5) * 14);
  }, {passive:true});
}

function startGyro(){
  window.addEventListener('deviceorientation', function(e){
    if (e.gamma == null || reduce) return;
    var g = Math.max(-30, Math.min(30, e.gamma));
    var b = Math.max(-30, Math.min(30, (e.beta || 45) - 45));
    queueTilt(g * 0.42, -b * 0.28);
  });
}

/* iOS 13+ requires a gesture before handing over motion data. Only
   render the control on devices that actually need it. */
function initMotionControl(root){
  var slot = root.querySelector('[data-um-motion]:not([data-um-motion-init])');
  if (!slot) return;
  slot.setAttribute('data-um-motion-init','1');

  if (typeof DeviceOrientationEvent !== 'undefined' &&
      typeof DeviceOrientationEvent.requestPermission === 'function'){
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'um-rail__motion';
    btn.textContent = 'Tilt to view';
    btn.addEventListener('click', function(){
      DeviceOrientationEvent.requestPermission().then(function(res){
        if (res === 'granted'){ startGyro(); btn.remove(); }
        else { btn.textContent = 'Motion unavailable'; btn.disabled = true; }
      }).catch(function(){ btn.remove(); });
    });
    slot.appendChild(btn);
  } else {
    startGyro();
  }
}

function initRail(root){
  var rail = root.querySelector('.um-rail:not([data-um-rail])');
  if (!rail) return;
  rail.setAttribute('data-um-rail','1');

  var passes = [].slice.call(rail.querySelectorAll('.um-pass'));
  var dots   = root.querySelector('[data-um-dots]');
  var label  = root.querySelector('[data-um-label]');

  passes.forEach(function(p){
    paintPass(p);
    p.addEventListener('click', function(e){
      if (e.target.closest('a')) return;          /* let the CTA link work */
      if (rail.dataset.dragged === '1') return;   /* swallow drag-clicks */
      var flipped = p.classList.toggle('is-flipped');
      p.setAttribute('aria-expanded', flipped);
      if (flipped) p.style.transform = '';
    });
  });

  if (dots){
    dots.innerHTML = '';
    passes.forEach(function(){ dots.appendChild(document.createElement('i')); });
  }

  var syncQueued = false;
  function sync(){
    syncQueued = false;
    var mid = rail.scrollLeft + rail.clientWidth / 2, best = 0, bd = Infinity;
    passes.forEach(function(p, i){
      var d = Math.abs((p.offsetLeft + p.offsetWidth / 2) - mid);
      if (d < bd){ bd = d; best = i; }
    });
    if (dots) [].forEach.call(dots.children, function(d, i){
      d.classList.toggle('is-on', i === best);
    });
    if (label && passes[best]) label.textContent = passes[best].dataset.label || '';
  }
  rail.addEventListener('scroll', function(){
    if (!syncQueued){ syncQueued = true; requestAnimationFrame(sync); }
  }, {passive:true});
  sync();

  /* drag-to-scroll with a mouse */
  var down = false, sx = 0, sl = 0;
  rail.addEventListener('pointerdown', function(e){
    if (e.pointerType !== 'mouse') return;
    down = true; sx = e.clientX; sl = rail.scrollLeft; rail.dataset.dragged = '0';
  });
  window.addEventListener('pointerup', function(){
    down = false;
    setTimeout(function(){ rail.dataset.dragged = '0'; }, 40);
  });
  window.addEventListener('pointermove', function(e){
    if (!down) return;
    if (Math.abs(e.clientX - sx) > 6) rail.dataset.dragged = '1';
    rail.scrollLeft = sl - (e.clientX - sx);
  });

  initMotionControl(root);
}

/* repaint every pass on resize, debounced — canvas work is not cheap */
var rt;
window.addEventListener('resize', function(){
  clearTimeout(rt);
  rt = setTimeout(function(){
    [].forEach.call(allPasses(), paintPass);
    [].forEach.call(document.querySelectorAll('[data-um-dissolve]'), drawDissolve);
  }, 220);
});

/* ── footer wordmark pixel dissolve ───────────────────────────────── */
function drawDissolve(cv){
  var ctx = cv.getContext('2d');
  var r = cv.parentElement.getBoundingClientRect();
  cv.width = Math.max(1, r.width * 0.48);
  cv.height = Math.max(1, r.height);
  var u = Math.max(6, r.height / 13);
  ctx.clearRect(0, 0, cv.width, cv.height);
  for (var x = 0; x < cv.width; x += u){
    for (var y = 0; y < cv.height; y += u){
      var bias = x / cv.width;
      if (Math.random() < bias * 0.9){
        ctx.fillStyle = Math.random() < bias * 0.75 ? '#0c0c0b'
          : (Math.random() < 0.5 ? '#EF7C11' : '#5FBCA9');
        ctx.fillRect(x, y, u, u);
      }
    }
  }
}
function initDissolve(root){
  var els = root.querySelectorAll('[data-um-dissolve]:not([data-um-dissolve-init])');
  [].forEach.call(els, function(cv){
    cv.setAttribute('data-um-dissolve-init','1');
    drawDissolve(cv);
  });
}

/* ── sticky ticket bar ────────────────────────────────────────────── */
function initTicketBar(root){
  var bar = root.querySelector('[data-um-tbar]:not([data-um-tbar-init])');
  if (!bar) return;
  bar.setAttribute('data-um-tbar-init','1');

  window.addEventListener('scroll', function(){
    bar.classList.toggle('is-up', window.scrollY > window.innerHeight * 0.75);
  }, {passive:true});

  var out = bar.querySelector('[data-um-count]');
  if (!out) return;
  var iso = out.getAttribute('data-um-count');
  var target = Date.parse(iso);
  if (isNaN(target)) return;

  function tick(){
    var d = Math.ceil((target - Date.now()) / 86400000);
    if (d > 1)       out.textContent = d + ' days to go';
    else if (d === 1) out.textContent = '1 day to go';
    else if (d === 0) out.textContent = 'Today';
    else              out.textContent = out.getAttribute('data-um-past') || '';
  }
  tick();
  setInterval(tick, 60000);
}

/* ═══════════════════════════════════════════════════════════════════
   VIDEO
   One rule underpins all of this: only ever one video playing, and
   never one the visitor can't see. Autoplaying a rail of six clips
   burns battery and mobile data for no conversion benefit.
   ═══════════════════════════════════════════════════════════════════ */

/* only one clip may carry sound at a time */
var soundOwner = null;
function claimSound(video){
  if (soundOwner && soundOwner !== video){
    soundOwner.muted = true;
    var prev = soundOwner.closest('.um-clip');
    if (prev) prev.querySelector('.um-clip__mute').textContent = '🔇';
  }
  soundOwner = video;
}

/* ── hero background loop ─────────────────────────────────────────── */
function initHeroVideo(root){
  var hero = root.querySelector('.um-hero--video:not([data-um-hero-init])');
  if (!hero) return;
  hero.setAttribute('data-um-hero-init','1');

  var vid = hero.querySelector('video');
  if (!vid) return;

  /* Reduced motion, or a metered connection: hold on the poster.
     The hero still reads correctly — it just doesn't move. */
  var saveData = navigator.connection && navigator.connection.saveData;
  if (reduce || saveData){ vid.removeAttribute('autoplay'); vid.pause(); return; }

  /* pause when scrolled past — a hero looping off-screen is pure waste */
  if ('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){
        if (en.isIntersecting) vid.play().catch(function(){});
        else vid.pause();
      });
    }, {threshold:0.15}).observe(hero);
  }

  var btn = hero.querySelector('[data-um-sound]');
  if (btn){
    btn.addEventListener('click', function(){
      vid.muted = !vid.muted;
      if (!vid.muted) claimSound(vid);
      btn.querySelector('span').textContent = vid.muted ? 'Sound off' : 'Sound on';
      vid.play().catch(function(){});
    });
  }
}

/* ── clip rail ────────────────────────────────────────────────────── */
function initReel(root){
  var reel = root.querySelector('.um-reel:not([data-um-reel])');
  if (!reel) return;
  reel.setAttribute('data-um-reel','1');

  var clips = [].slice.call(reel.querySelectorAll('.um-clip'));

  clips.forEach(function(clip){
    var vid = clip.querySelector('video');
    var mute = clip.querySelector('.um-clip__mute');

    if (vid && mute){
      mute.addEventListener('click', function(e){
        e.preventDefault();
        e.stopPropagation();          /* don't follow the card's link */
        vid.muted = !vid.muted;
        if (!vid.muted){ claimSound(vid); vid.play().catch(function(){}); }
        mute.textContent = vid.muted ? '🔇' : '🔊';
      });
    }
  });

  /* play only what's actually on screen, one at a time */
  if ('IntersectionObserver' in window && !reduce){
    var vo = new IntersectionObserver(function(entries){
      /* pick the most visible clip and let only that one run */
      var best = null, bestRatio = 0;
      entries.forEach(function(en){
        var clip = en.target, vid = clip.querySelector('video');
        if (!vid) return;
        if (!en.isIntersecting){
          vid.pause(); clip.classList.remove('is-playing');
        } else if (en.intersectionRatio > bestRatio){
          bestRatio = en.intersectionRatio; best = clip;
        }
      });
      if (best && bestRatio > 0.6){
        var v = best.querySelector('video');
        if (v){
          /* load lazily — src only attaches when it's nearly in view */
          if (v.dataset.src && !v.src){ v.src = v.dataset.src; }
          v.play().then(function(){ best.classList.add('is-playing'); }).catch(function(){});
        }
      }
    }, {threshold:[0, 0.6, 0.9]});
    clips.forEach(function(c){ vo.observe(c); });
  }
}

/* ── audience toggle: first-timers vs returners ───────────────────── */
function initAudience(root){
  var wrap = root.querySelector('[data-um-tabs]:not([data-um-tabs-init])');
  if (!wrap) return;
  wrap.setAttribute('data-um-tabs-init','1');

  var section = wrap.closest('[data-um-reel-section]') || root;
  var buttons = [].slice.call(wrap.querySelectorAll('button'));
  var lede    = section.querySelector('[data-um-lede]');
  var reel    = section.querySelector('.um-reel');

  function apply(mode){
    buttons.forEach(function(b){
      b.setAttribute('aria-selected', String(b.dataset.audience === mode));
    });
    if (lede) lede.textContent = lede.dataset[mode] || lede.textContent;

    [].forEach.call(section.querySelectorAll('.um-clip'), function(clip){
      var a = clip.dataset.audience || 'both';
      var show = (a === 'both' || a === mode);
      clip.hidden = !show;
      if (!show){
        var v = clip.querySelector('video');
        if (v){ v.pause(); clip.classList.remove('is-playing'); }
      }
    });

    if (reel) reel.scrollLeft = 0;
  }

  buttons.forEach(function(b){
    b.addEventListener('click', function(){ apply(b.dataset.audience); });
  });

  apply(wrap.dataset.umTabs || 'first');
}

/* ── bootstrap ────────────────────────────────────────────────────── */
function initAll(root){
  root = root || document;
  paintBody();
  initReveal(root);
  initChrome(root);
  initRail(root);
  initDissolve(root);
  initTicketBar(root);
  initHeroVideo(root);
  initAudience(root);
  initReel(root);
}

if (document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded', function(){ initAll(document); });
} else {
  initAll(document);
}

/* theme editor: sections are swapped in and out of the DOM live */
document.addEventListener('shopify:section:load', function(e){ initAll(e.target); });
document.addEventListener('shopify:section:reorder', function(){ initAll(document); });

})();
